/****************************************************************************************
 * File Name    : FilterWorkReport.vue
 * Function     : 필터 일일 작업일지 - 일지관리
 * Author       : 
 * Description  : 일일 작업일지 보고서 관리
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2026.02.17  	        	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title="필터 일일 작업일지 - 일지관리" />
                </div>
            </a-col>
        </a-row>
        <a-divider type='horizontal' />
        
        <a-form class="" layout="vertical">
            <a-card>
                <a-space align="end">
                    <a-input default-value="" v-model="filterCS">
                        <a-select slot="addonAfter" default-value="라인명" v-model="filterField">
                            <a-select-option value="라인명">라인명</a-select-option>
                            <a-select-option value="생산모델">생산모델</a-select-option>
                            <a-select-option value="작성자">작성자</a-select-option>
                        </a-select>
                    </a-input>

                    <span style="display: inline-block; margin-bottom: 5px; margin-left: 10px;">일자</span>
                    <date-picker v-model="filterDateStartCS" valueType="format" style="width:120px;"></date-picker>
                    <span style="display: inline-block; margin-bottom: 5px;">~</span>
                    <date-picker v-model="filterDateEndCS" valueType="format" style="width:120px;"></date-picker>
                    
                    <a-button type="primary" ghost="true" @click="filterCSList">검색</a-button>
                    <a-button @click="resetCSList">초기화</a-button>
                </a-space>
                <p/>
                <div style="position:relative;">
                    <img id="loading-data" class="more-btn" src="../assets/images/Loading_2.gif" v-if="isLoading" style="position:absolute; top:50%; left:50%; margin-top:-30px; margin-left:-30px; width:60px; z-index:10;" />
                    <a-table :columns="columns" size="small" :bordered="false" :data-source="data" :pagination="pagination" :scroll="{ x: 0, y: '80vh' }" @change="handleTableChange">
                        <span slot="tags" slot-scope="tags">
                            <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ green: (tag === '작성완료'), navy: (tag === '승인완료') }">
                                {{ tag.toUpperCase() }}
                            </a-tag>
                        </span>
                        <span slot="action" slot-scope="record">
                            <span style='cursor:pointer' @click="handlerToView(record.key)"><a-icon type="eye" /> View</span>
                            <a-divider type="vertical" />
                            <span style='cursor:pointer' @click="handlerToApprove(record.key)" v-if="record.tags[0] === '작성완료'"><a-icon type="check-circle" /> 승인</span>
                            <span style='cursor:pointer' @click="handlerToCancelApprove(record.key)" v-if="record.tags[0] === '승인완료'"><a-icon type="close-circle" /> 승인취소</span>
                            <a-divider type="vertical" />
                            <span style='cursor:pointer' @click="handlerToDelete(record.key)"><a-icon type="delete" /> Delete</span>
                        </span>
                    </a-table>
                </div>
            </a-card>
        </a-form>

        <!-- 일지 상세보기 Drawer -->
        <a-drawer 
            title="일일 작업일지 상세보기" 
            placement="right" 
            :closable="true" 
            :visible="flagForDrawer" 
            @close="handlerForCloseDrawer" 
            width="100%"
        >
            <div id="print">
                <!-- 승인정보 -->
                <div class="approval-info" v-if="viewData.basicInfo.approverName">
                    <a-icon type="check-circle" theme="filled" style="color:#52c41a;margin-right:6px;" />
                    승인완료 — 승인자: <strong>{{ viewData.basicInfo.approverName }}</strong>
                    &nbsp;|&nbsp; 승인일시: {{ viewData.basicInfo.approvalDate }}
                </div>

                <!-- 제목/날짜 -->
                <div class="vw-header">
                    <div class="vw-title">{{ viewData.templateTexts.managerInput || '' }} 작업일보</div>
                    <div class="vw-date">
                        <span class="vw-val">{{ viewData.workYear }}</span> 년
                        <span class="vw-val">{{ viewData.workMonth }}</span> 월
                        <span class="vw-val">{{ viewData.workDay }}</span> 일
                        <span class="vw-val">{{ viewData.workDayOfWeek }}</span> 요일
                    </div>
                </div>

                <!-- 기본정보 -->
                <div class="vw-meta-row">
                    <span class="vw-meta-label">라인명</span><span class="vw-meta-val">{{ viewData.basicInfo.lineName }}</span>
                    <span class="vw-meta-label">작성자</span><span class="vw-meta-val">{{ viewData.basicInfo.writer }}</span>
                    <span class="vw-meta-label">생산 모델</span><span class="vw-meta-val">{{ viewData.basicInfo.productModel }}</span>
                </div>

                <!-- 2. 자주보전 -->
                <div class="vw-section-title">2. 자주보전</div>
                <div style="display:flex;gap:12px;margin-bottom:8px;">
                    <div style="flex:1;">
                        <div class="vw-subsection-title">실내 온도/습도</div>
                        <table class="vw-table">
                            <thead><tr><th></th><th>오전 1</th><th>오전 2</th><th>오후 1</th><th>오후 2</th></tr></thead>
                            <tbody>
                                <tr>
                                    <td class="vw-label">℃</td>
                                    <td>{{ viewData.tempHumidity.am1_temp }}</td>
                                    <td>{{ viewData.tempHumidity.am2_temp }}</td>
                                    <td>{{ viewData.tempHumidity.pm1_temp }}</td>
                                    <td>{{ viewData.tempHumidity.pm2_temp }}</td>
                                </tr>
                                <tr>
                                    <td class="vw-label">%</td>
                                    <td>{{ viewData.tempHumidity.am1_hum }}</td>
                                    <td>{{ viewData.tempHumidity.am2_hum }}</td>
                                    <td>{{ viewData.tempHumidity.pm1_hum }}</td>
                                    <td>{{ viewData.tempHumidity.pm2_hum }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="vw-subsection-title" style="margin-top:6px;">설비보전내용</div>
                        <div class="vw-textarea-view">{{ viewData.equipmentMaintenance }}</div>
                    </div>
                    <div style="flex:1;">
                        <div class="vw-subsection-title">혼합기 원료 투입량 체크</div>
                        <table class="vw-table">
                            <thead><tr><th>구분</th><th>활성탄 투입량</th><th>바인디 투입량</th></tr></thead>
                            <tbody>
                                <tr>
                                    <td class="vw-label">오전 1</td>
                                    <td>{{ viewData.rawMaterial.am1_carbon }}<span v-if="viewData.rawMaterial.am1_carbon"> kg</span></td>
                                    <td>{{ viewData.rawMaterial.am1_binder }}<span v-if="viewData.rawMaterial.am1_binder"> kg</span></td>
                                </tr>
                                <tr>
                                    <td class="vw-label">오전 2</td>
                                    <td>{{ viewData.rawMaterial.am2_carbon }}<span v-if="viewData.rawMaterial.am2_carbon"> kg</span></td>
                                    <td>{{ viewData.rawMaterial.am2_binder }}<span v-if="viewData.rawMaterial.am2_binder"> kg</span></td>
                                </tr>
                                <tr>
                                    <td class="vw-label">오후 1</td>
                                    <td>{{ viewData.rawMaterial.pm1_carbon }}<span v-if="viewData.rawMaterial.pm1_carbon"> kg</span></td>
                                    <td>{{ viewData.rawMaterial.pm1_binder }}<span v-if="viewData.rawMaterial.pm1_binder"> kg</span></td>
                                </tr>
                                <tr>
                                    <td class="vw-label">오후 2</td>
                                    <td>{{ viewData.rawMaterial.pm2_carbon }}<span v-if="viewData.rawMaterial.pm2_carbon"> kg</span></td>
                                    <td>{{ viewData.rawMaterial.pm2_binder }}<span v-if="viewData.rawMaterial.pm2_binder"> kg</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- 3. 성능평가 -->
                <div class="vw-section-title">3. 성능평가</div>
                <div style="margin-bottom:4px;font-size:12px;">
                    <span class="vw-label" style="margin-right:6px;">길이 평가 모델:</span>
                    <strong>{{ viewData.length.model }}</strong>
                </div>
                <table class="vw-table vw-perf-table">
                    <thead>
                        <tr>
                            <th rowspan="2"></th>
                            <th colspan="3">강도 평가</th>
                            <th colspan="3">중량 평가</th>
                            <th colspan="4">길이 평가</th>
                        </tr>
                        <tr>
                            <th>1호기</th><th>2호기</th><th>3호기</th>
                            <th>1호기</th><th>2호기</th><th>3호기</th>
                            <th>1호기</th><th>2호기</th><th>3호기</th><th>특이사항</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="slot in timeSlots" :key="slot.key">
                            <td class="vw-label">{{ slot.label }}</td>
                            <td>{{ viewData.strength[slot.key + '_m1'] }}</td>
                            <td>{{ viewData.strength[slot.key + '_m2'] }}</td>
                            <td>{{ viewData.strength[slot.key + '_m3'] }}</td>
                            <td>{{ viewData.weight[slot.key + '_m1'] }}<span v-if="viewData.weight[slot.key + '_m1']"> g</span></td>
                            <td>{{ viewData.weight[slot.key + '_m2'] }}<span v-if="viewData.weight[slot.key + '_m2']"> g</span></td>
                            <td>{{ viewData.weight[slot.key + '_m3'] }}<span v-if="viewData.weight[slot.key + '_m3']"> g</span></td>
                            <td>{{ viewData.length[slot.key + '_m1'] }}</td>
                            <td>{{ viewData.length[slot.key + '_m2'] }}</td>
                            <td>{{ viewData.length[slot.key + '_m3'] }}</td>
                            <td>{{ viewData.length[slot.key + '_special'] }}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- 4. 탁도/잔류염소 -->
                <div class="vw-section-title">4. 성능평가 (탁도/잔류염소 평가)</div>
                <div style="display:flex;gap:12px;">
                    <!-- 오전 -->
                    <div style="flex:1;">
                        <div class="vw-subsection-title">오전</div>
                        <div class="vw-note-text">{{ viewData.templateTexts.turbidityNote }}</div>
                        <table class="vw-table">
                            <thead>
                                <tr><th>모델</th><th>평가자</th><th>#1탁도</th><th>#1유량</th><th>#2탁도</th><th>#2유량</th><th>#3탁도</th><th>#3유량</th><th>특이사항</th></tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ viewData.turbidityAm.model }}</td>
                                    <td>{{ viewData.turbidityAm.evaluator }}</td>
                                    <td>{{ viewData.turbidityAm.m1_turbidity }}</td>
                                    <td>{{ viewData.turbidityAm.m1_flow }}</td>
                                    <td>{{ viewData.turbidityAm.m2_turbidity }}</td>
                                    <td>{{ viewData.turbidityAm.m2_flow }}</td>
                                    <td>{{ viewData.turbidityAm.m3_turbidity }}</td>
                                    <td>{{ viewData.turbidityAm.m3_flow }}</td>
                                    <td>{{ viewData.turbidityAm.specialNote }}</td>
                                </tr>
                                <tr>
                                    <td class="vw-label" colspan="2">원수탁도 / 시간</td>
                                    <td>{{ viewData.turbidityAm.sourceWaterTurbidity }}</td>
                                    <td>{{ viewData.turbidityAm.time }}</td>
                                    <td colspan="5"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="vw-note-text" style="margin-top:6px;">{{ viewData.templateTexts.concentrationFormula }}</div>
                        <table class="vw-table" style="margin-top:4px;">
                            <thead>
                                <tr>
                                    <th>시작투입량(ml)</th><th>평가자</th>
                                    <th>중량</th><th>중량</th><th>중량</th>
                                    <th rowspan="3">특이사항</th>
                                </tr>
                                <tr>
                                    <th>원수공급량(1t)</th><th>용해농도</th>
                                    <th>#1농도(g)</th><th>#2농도(g)</th><th>#3농도(g)</th>
                                </tr>
                                <tr>
                                    <th></th><th></th>
                                    <th>#1제거율(%)</th><th>#2제거율(%)</th><th>#3제거율(%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ viewData.chlorineAm.startInput_ml }}</td>
                                    <td>{{ viewData.chlorineAm.evaluator }}</td>
                                    <td>{{ viewData.chlorineAm.m1_weight }}</td>
                                    <td>{{ viewData.chlorineAm.m2_weight }}</td>
                                    <td>{{ viewData.chlorineAm.m3_weight }}</td>
                                    <td rowspan="3" style="vertical-align:top;white-space:pre-wrap;">{{ viewData.chlorineAm.specialNote }}</td>
                                </tr>
                                <tr>
                                    <td>{{ viewData.chlorineAm.sourceSupply_1t }}</td>
                                    <td>{{ viewData.chlorineAm.dissolvedConc }}</td>
                                    <td>{{ viewData.chlorineAm.m1_conc }}</td>
                                    <td>{{ viewData.chlorineAm.m2_conc }}</td>
                                    <td>{{ viewData.chlorineAm.m3_conc }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>{{ viewData.chlorineAm.m1_rate }}</td>
                                    <td>{{ viewData.chlorineAm.m2_rate }}</td>
                                    <td>{{ viewData.chlorineAm.m3_rate }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="vw-note-text">{{ viewData.templateTexts.chlorineNote }}</div>
                    </div>

                    <!-- 오후 -->
                    <div style="flex:1;">
                        <div class="vw-subsection-title">오후</div>
                        <div class="vw-note-text">{{ viewData.templateTexts.turbidityNote }}</div>
                        <table class="vw-table">
                            <thead>
                                <tr><th>모델</th><th>평가자</th><th>#1탁도</th><th>#1유량</th><th>#2탁도</th><th>#2유량</th><th>#3탁도</th><th>#3유량</th><th>특이사항</th></tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ viewData.turbidityPm.model }}</td>
                                    <td>{{ viewData.turbidityPm.evaluator }}</td>
                                    <td>{{ viewData.turbidityPm.m1_turbidity }}</td>
                                    <td>{{ viewData.turbidityPm.m1_flow }}</td>
                                    <td>{{ viewData.turbidityPm.m2_turbidity }}</td>
                                    <td>{{ viewData.turbidityPm.m2_flow }}</td>
                                    <td>{{ viewData.turbidityPm.m3_turbidity }}</td>
                                    <td>{{ viewData.turbidityPm.m3_flow }}</td>
                                    <td>{{ viewData.turbidityPm.specialNote }}</td>
                                </tr>
                                <tr>
                                    <td class="vw-label" colspan="2">원수탁도 / 시간</td>
                                    <td>{{ viewData.turbidityPm.sourceWaterTurbidity }}</td>
                                    <td>{{ viewData.turbidityPm.time }}</td>
                                    <td colspan="5"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="vw-note-text" style="margin-top:6px;">{{ viewData.templateTexts.concentrationFormula }}</div>
                        <table class="vw-table" style="margin-top:4px;">
                            <thead>
                                <tr>
                                    <th>시작투입량(ml)</th><th>평가자</th>
                                    <th>중량</th><th>중량</th><th>중량</th>
                                    <th rowspan="3">특이사항</th>
                                </tr>
                                <tr>
                                    <th>원수공급량(1t)</th><th>용해농도</th>
                                    <th>#1농도(g)</th><th>#2농도(g)</th><th>#3농도(g)</th>
                                </tr>
                                <tr>
                                    <th></th><th></th>
                                    <th>#1제거율(%)</th><th>#2제거율(%)</th><th>#3제거율(%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ viewData.chlorinePm.startInput_ml }}</td>
                                    <td>{{ viewData.chlorinePm.evaluator }}</td>
                                    <td>{{ viewData.chlorinePm.m1_weight }}</td>
                                    <td>{{ viewData.chlorinePm.m2_weight }}</td>
                                    <td>{{ viewData.chlorinePm.m3_weight }}</td>
                                    <td rowspan="3" style="vertical-align:top;white-space:pre-wrap;">{{ viewData.chlorinePm.specialNote }}</td>
                                </tr>
                                <tr>
                                    <td>{{ viewData.chlorinePm.sourceSupply_1t }}</td>
                                    <td>{{ viewData.chlorinePm.dissolvedConc }}</td>
                                    <td>{{ viewData.chlorinePm.m1_conc }}</td>
                                    <td>{{ viewData.chlorinePm.m2_conc }}</td>
                                    <td>{{ viewData.chlorinePm.m3_conc }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>{{ viewData.chlorinePm.m1_rate }}</td>
                                    <td>{{ viewData.chlorinePm.m2_rate }}</td>
                                    <td>{{ viewData.chlorinePm.m3_rate }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="vw-note-text">{{ viewData.templateTexts.chlorineNote }}</div>
                    </div>
                </div>

                <!-- 하단 -->
                <table class="vw-table" style="margin-top:16px;width:100%;">
                    <tbody>
                        <tr>
                            <td class="vw-label" style="width:100px;">유실 내용</td>
                            <td style="width:45%;text-align:left;padding:6px;">{{ viewData.wasteContent }}</td>
                            <td class="vw-label" style="width:90px;">평가 등당</td>
                            <td>{{ viewData.evalGrade }}<span v-if="viewData.evalGrade"> g</span></td>
                            <td class="vw-label" style="width:90px;">작업 등당</td>
                            <td>{{ viewData.workGrade }}<span v-if="viewData.workGrade"> kg</span></td>
                        </tr>
                    </tbody>
                </table>

                <a-divider />
                <div id="print-button-container" style="margin-top:20px;text-align:center;">
                    <a-button @click="handlerForCloseDrawer">나가기</a-button>
                    <a-button @click="print()" style="margin-left:16px;"><a-icon type="printer" /> 인쇄</a-button>
                    <a-button v-if="currentViewState !== 'FW_F'" type="primary" @click="handlerForApproveFromDrawer(true)" style="margin-left:16px;">
                        <a-icon type="check-circle" /> 승인완료
                    </a-button>
                    <a-button v-if="currentViewState === 'FW_F'" type="danger" @click="handlerForApproveFromDrawer(false)" style="margin-left:16px;">
                        <a-icon type="close-circle" /> 승인완료 취소
                    </a-button>
                </div>
            </div><!-- /#print -->
        </a-drawer>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import PageHeader from "../components/PageHeader.vue";

const columns = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '생산모델', dataIndex: 'productModel', key: 'productModel' },
    { title: '작성자', dataIndex: 'writer', key: 'writer' },
    { title: '작성일자', dataIndex: 'date', key: 'date' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 280 },
];

function makeDefaultViewData() {
    return {
        basicInfo: { lineName: '', writer: '', productModel: '', approverName: '', approvalDate: '' },
        templateTexts: { managerInput: '', turbidityNote: '', concentrationFormula: '', chlorineNote: '' },
        workYear: '', workMonth: '', workDay: '', workDayOfWeek: '',
        tempHumidity: {},
        rawMaterial: {},
        equipmentMaintenance: '',
        strength: {},
        weight: {},
        length: {},
        turbidityAm: {},
        chlorineAm: {},
        turbidityPm: {},
        chlorinePm: {},
        wasteContent: '',
        evalGrade: '',
        workGrade: ''
    };
}

export default {
    name: 'FilterWorkReport',
    components: {
        PageHeader,
        DatePicker,
    },
    data() {
        return {
            columns,
            data: [],
            filterCS: '',
            filterField: '라인명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            isLoading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            flagForDrawer: false,
            currentViewKey: null,
            currentViewState: '',
            viewData: makeDefaultViewData()
        };
    },
    computed: {
        timeSlots() {
            return [
                { key: 'am1', label: '오전 1' },
                { key: 'am2', label: '오전 2' },
                { key: 'pm1', label: '오후 1' },
                { key: 'pm2', label: '오후 2' }
            ];
        }
    },
    mounted() {
        this.fetchReportList();
    },
    methods: {
        fetchReportList() {
            this.isLoading = true;
            const page = this.pagination.current - 1;
            const size = this.pagination.pageSize;
            let url = `${this.$store.state.nodeApiUrl}/filter/work/report/list?size=${size}&page=${page}`;
            if (this.filterDateStartCS) url += `&start_date=${this.filterDateStartCS}`;
            if (this.filterDateEndCS) url += `&end_date=${this.filterDateEndCS}`;
            
            this.$http.get(url).then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.pagination.total = response.data.data.totalElements || 0;
                    this.data = response.data.data.content.map(item => ({
                        key: item.productCsSeq,
                        tags: [item.state === 'FW_D' ? '작성완료' : '승인완료'],
                        lineName: item.line, productModel: item.productModel || '-',
                        writer: item.manager, date: item.updated ? item.updated.split(' ')[0] : '',
                        updated: item.updated, checkResult: item.checkResult || 'OK'
                    }));
                }
                this.isLoading = false;
            }).catch((error) => { console.error(error); this.$message.error('목록 조회에 실패했습니다.'); this.isLoading = false; });
        },
        filterCSList() {
            console.log('Filter:', this.filterField, this.filterCS);
            this.fetchReportList();
        },
        resetCSList() {
            this.filterCS = '';
            this.filterDateStartCS = '';
            this.filterDateEndCS = '';
            this.fetchReportList();
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchReportList();
        },
        handlerToView(key) {
            const listItem = this.data.find(d => d.key === key);
            this.currentViewKey = key;
            this.currentViewState = listItem ? (listItem.tags[0] === '승인완료' ? 'FW_F' : 'FW_D') : 'FW_D';

            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/work/template/item/${key}`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        const data = response.data.data;
                        const isApproved = data.state === 'FW_F' || this.currentViewState === 'FW_F';
                        const tt = data.templateTexts || {};
                        const wd = data.worksheetData || {};
                        const wdBasic = wd.basicInfo || {};

                        const vd = makeDefaultViewData();
                        vd.basicInfo.lineName = data.lineName || '';
                        vd.basicInfo.writer = data.writer || '';
                        vd.basicInfo.productModel = data.productModel || '';
                        vd.basicInfo.approverName = isApproved ? (data.approver || data.updater || '') : '';
                        vd.basicInfo.approvalDate = isApproved ? (data.updated || '') : '';

                        vd.templateTexts.managerInput = tt.managerInput || '';
                        vd.templateTexts.turbidityNote = tt.turbidityNote || '10NTU 이하 유량:15~22';
                        vd.templateTexts.concentrationFormula = tt.concentrationFormula || '(원수농도-측정농도)/원수 농도*100';
                        vd.templateTexts.chlorineNote = tt.chlorineNote || '염소 제거율 : 85% 이상';

                        vd.workYear = wdBasic.workYear || '';
                        vd.workMonth = wdBasic.workMonth || '';
                        vd.workDay = wdBasic.workDay || '';
                        vd.workDayOfWeek = wdBasic.workDayOfWeek || '';

                        vd.tempHumidity = wd.tempHumidity || {};
                        vd.rawMaterial = wd.rawMaterial || {};
                        vd.equipmentMaintenance = wd.equipmentMaintenance || '';
                        vd.strength = wd.strength || {};
                        vd.weight = wd.weight || {};
                        vd.length = wd.length || {};
                        vd.turbidityAm = wd.turbidityAm || {};
                        vd.chlorineAm = wd.chlorineAm || {};
                        vd.turbidityPm = wd.turbidityPm || {};
                        vd.chlorinePm = wd.chlorinePm || {};
                        vd.wasteContent = wd.wasteContent || '';
                        vd.evalGrade = wd.evalGrade || '';
                        vd.workGrade = wd.workGrade || '';

                        this.viewData = vd;
                        this.flagForDrawer = true;
                    }
                }).catch((error) => { console.error(error); this.$message.error('데이터 조회에 실패했습니다.'); });
        },
        handlerToApprove(key) {
            this.$confirm({
                title: '승인 확인',
                content: '해당 일지를 승인하시겠습니까?',
                onOk: () => {
                    this.$http.put(`${this.$store.state.nodeApiUrl}/filter/state/${key}`, {
                        state: 'FW_F',
                        approver: sessionStorage.getItem('user_name') || ''
                    })
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('승인되었습니다.');
                                this.fetchReportList();
                            }
                        }).catch((error) => { console.error(error); this.$message.error('승인에 실패했습니다.'); });
                }
            });
        },
        handlerToCancelApprove(key) {
            this.$confirm({
                title: '승인취소 확인',
                content: '승인을 취소하시겠습니까?',
                onOk: () => {
                    this.$http.put(`${this.$store.state.nodeApiUrl}/filter/state/${key}`, { state: 'FW_D', approver: '' })
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('승인이 취소되었습니다.');
                                this.fetchReportList();
                            }
                        }).catch((error) => { console.error(error); this.$message.error('승인취소에 실패했습니다.'); });
                }
            });
        },
        handlerToDelete(key) {
            this.$confirm({
                title: '삭제 확인',
                content: '정말 삭제하시겠습니까?',
                onOk: () => {
                    this.$http.delete(`${this.$store.state.nodeApiUrl}/filter/delete/${key}`)
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('삭제되었습니다.');
                                this.fetchReportList();
                            }
                        }).catch((error) => { console.error(error); this.$message.error('삭제에 실패했습니다.'); });
                }
            });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        print() {
            const prtHtml = document.getElementById('print').innerHTML;

            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }

            const WinPrint = window.open('', '', 'left=0,top=0,width=1600,height=900,toolbar=0,scrollbars=0,status=0');

            WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body>
                ${prtHtml}
            </body>
            </html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.onload = function() {
                setTimeout(function() {
                    WinPrint.print();
                    WinPrint.close();
                }, 1000);
            };
        },
        handlerForApproveFromDrawer(approve) {
            const newState = approve ? 'FW_F' : 'FW_D';
            const lineName = this.viewData.basicInfo.lineName || '';
            const model = this.viewData.basicInfo.productModel || '';
            const message = approve
                ? `${lineName} ${model} 보고서를 승인하시겠습니까?`
                : `${lineName} ${model} 보고서를 승인취소하시겠습니까?`;

            if (confirm(message)) {
                this.$http.put(`${this.$store.state.nodeApiUrl}/filter/state/${this.currentViewKey}`, {
                    state: newState,
                    approver: approve ? (sessionStorage.getItem('user_name') || '') : ''
                })
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success(approve ? '승인되었습니다.' : '승인이 취소되었습니다.');
                            this.flagForDrawer = false;
                            this.fetchReportList();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.$message.error(approve ? '승인에 실패했습니다.' : '승인취소에 실패했습니다.');
                    });
            }
        },
    }
};
</script>

<style scoped>
.state-btn { font-weight: bold; padding: 2px 8px; }
.state-btn.green { background-color: #52c41a; color: white; }
.state-btn.navy { background-color: #1890ff; color: white; }

/* 일지 뷰어 */
.approval-info {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
    padding: 6px 12px;
    margin-bottom: 12px;
    font-size: 13px;
}
.vw-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #333;
    padding-bottom: 8px;
    margin-bottom: 10px;
}
.vw-title {
    font-size: 20px;
    font-weight: bold;
    color: #c0392b;
}
.vw-date { font-size: 13px; color: #333; }
.vw-val {
    display: inline-block;
    min-width: 32px;
    border-bottom: 1px solid #999;
    text-align: center;
    margin: 0 2px;
    font-weight: bold;
}
.vw-meta-row {
    display: flex;
    gap: 0;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    font-size: 12px;
}
.vw-meta-label {
    background: #f5f5f5;
    padding: 4px 8px;
    font-weight: bold;
    border-right: 1px solid #ddd;
    white-space: nowrap;
}
.vw-meta-val {
    padding: 4px 12px;
    border-right: 1px solid #ddd;
    min-width: 80px;
}
.vw-section-title {
    font-size: 13px;
    font-weight: bold;
    background: #e8f4fd;
    padding: 3px 8px;
    margin: 10px 0 5px 0;
    border-left: 4px solid #2980b9;
}
.vw-subsection-title { font-size: 11px; font-weight: bold; color: #555; margin-bottom: 3px; }
.vw-note-text { font-size: 12px; color: #c0392b; font-weight: bold; padding: 2px 0; }
.vw-textarea-view {
    border: 1px solid #ddd;
    background: #fafafa;
    min-height: 50px;
    padding: 4px 6px;
    font-size: 12px;
    white-space: pre-wrap;
}
.vw-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    margin-bottom: 3px;
}
.vw-table th, .vw-table td {
    border: 1px solid #bbb;
    padding: 4px 6px;
    text-align: center;
    vertical-align: middle;
    height: 26px;
}
.vw-table th { background: #f0f4f8; font-weight: bold; font-size: 11px; }
.vw-table td.vw-label { background: #f7f7f7; font-weight: bold; font-size: 11px; white-space: nowrap; }
.vw-perf-table th, .vw-perf-table td { min-width: 55px; }
</style>
